import $ from 'jquery';
import * as registry from '../../../home24/core/registry';
import * as lightbox from '../../../home24/helpers/lightbox';
import * as cartHelper from '../../tracking/cart/helper';
import CartOverlayEvents from '../../tracking/cart/CartOverlayEvents';
import { onArticleAddedToCart } from '../../../home24-shared/tracking/cart/cart';

/**
 * shows overlay and results of adding to cart
 */

var selectors = {
    ajaxOverlay: '#ajaxOverlay',
    closeButton: '#js-close-cart-overlay-button'
};

var $scope = $('body');
var $ajaxOverlay;
var trackingCartOverlay;
var trackingPixelsAdded = false;


/**
 * Add ThreatMetrix pixel
 */
var addTrackingPixels = function () {
    var trackingPixelsHtml = registry.get('trackingPixelsHtml');

    if (typeof trackingPixelsHtml === 'string') {
        $scope.append(trackingPixelsHtml);
    }
};

/**
 * show lightbox with html returned from server
 * @param data
 */
var showSuccessLightbox = function (data) {
    lightbox.setConfig({
        className: 'pdp-cart-success',
        onClose: function () {
            if (trackingCartOverlay) {
                trackingCartOverlay.destroy();
                trackingCartOverlay = null;
            }
        },
        repositionOnScreenResize: true
    }).open(data);

    $scope.find(selectors.closeButton).off('click').on('click', function (event) {
        event.preventDefault();
        lightbox.close();
    });

    if (trackingPixelsAdded === false) {
        addTrackingPixels();
        trackingPixelsAdded = true;
    }
};

/**
 * Update number of items in cart in header icon
 * @param {int} number
 */
export function updateCartItemsCount(number) {
    $.publish('update.header:cart', number);
}

export function init($newScope) {
    if ($newScope && $newScope instanceof $) {
        $scope = $newScope;
    }
    $ajaxOverlay = $scope.find(selectors.ajaxOverlay);
    trackingPixelsAdded = false;
}

export function showLoadingOverlay() {
    $ajaxOverlay.show();
}

export function hideLoadingOverlay() {
    $ajaxOverlay.hide();
}

export function showSuccessOverlay(data) {
    hideLoadingOverlay();

    if (typeof data.html === 'string' && data.html.length > 0) {
        showSuccessLightbox(data.html);
    }

    /** @namespace data.cartItemsCount */
    if (typeof data.cartItemsCount === 'number') {
        updateCartItemsCount(data.cartItemsCount);
    }

    /**
     * @see REBOOT-14888
     */
    if (typeof data.trackingData === 'object') {
        cartHelper.setOverlayData(data.trackingData);
        onArticleAddedToCart(data.trackingData, 'pdp_product');
        cartHelper.pushAddToCartOverlayEvent();

        trackingCartOverlay = new CartOverlayEvents({
            el: lightbox.getLightboxContainer()
        });

    }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/addToCart/cartOverlayView.js
 **/